export const THIRD_PARTY_SENSOR_CARD_DETAILS_CARD_FRENCH_LOCALE = {
  title: "Détails du capteur",
};
